import type { ICategory, ITop8CategoryList } from '../types';

  
export const sortCategories = (allCategories: ICategory[], topCategories: ITop8CategoryList[] | undefined) => {
  const topCategoryIds = (topCategories ?? []).map((cat: { id: string; }) => cat.id);
  
  const sorted: ICategory[] = [];
  const unmatched: ICategory[] = [];
  
  allCategories.forEach((category: ICategory) => {
    if (topCategoryIds.includes(category.id)) {
      sorted.push(category);
    } else {
      unmatched.push(category);
    }
  });

  unmatched.forEach((category: ICategory) => { sorted.push(category); });
  return sorted;
};

export const handleSetButton = (showCategories: boolean, buttonText: string, setShowAllCategories: React.Dispatch<React.SetStateAction<boolean>>, setButtonText: React.Dispatch<React.SetStateAction<string>>) => {
  setShowAllCategories(!showCategories);

  if (buttonText === 'View all categories') {
    setButtonText('View less categories');
  } else {
    setButtonText('View all categories');
  }
};

